import { useStaticData } from '@mc/static-data-react'
import { EventTypes, PageSource } from '@mc/track-event'
import BusinessBanner from 'components/BusinessBanner'
import { SeriesEmailCapture } from 'components/EmailCapture'
import { FAQ } from 'components/FAQ'
import { RelatedArticles } from 'components/RelatedArticles'
import { Subscription } from 'components/Subscription'
import { CertificatesBanner } from 'experiments/mccerts-1116_v1_pre-paywall_certificates_banner'
import { MCCERTS_1116_V1_CLASS_PAGE_CERTIFICATES_BANNER_FLAG } from 'experiments/mccerts-1116_v1_pre-paywall_certificates_banner/constants'
import { EpisodeStaticData } from '../../[episodeSlug].page'
import { EpisodeList } from '../EpisodeList'
import { RelatedContent } from '../RelatedContent'
import { SeriesDetails } from '../SeriesDetails'
import { SubcatCoursesSection } from '../SubcatCoursesSection'

export const BelowTheFold = () => {
  const { episode, course } = useStaticData<EpisodeStaticData>()

  return (
    <>
      <div className='container'>
        <EpisodeList />
        <SeriesDetails />
      </div>
      <SubcatCoursesSection />
      <RelatedContent />
      <SeriesEmailCapture
        trackProps={{
          location: 'episode_page_body_new_episode',
          campaign: 'new_releases',
          contentType: 'series',
          slug: course.slug,
        }}
      />
      <CertificatesBanner
        flagName={MCCERTS_1116_V1_CLASS_PAGE_CERTIFICATES_BANNER_FLAG}
      />
      <BusinessBanner pageSource={PageSource.EPISODE_PAGE} />
      <Subscription eventProps={{ episode: episode.slug || '' }} />
      <FAQ
        className='container mc-mst-12 mc-py-10'
        eventType={EventTypes.EPISODE_PAGE_CLICK}
        eventLocation='episode-page-body-faq'
        pageSource={PageSource.EPISODE_PAGE}
      />
      <RelatedArticles />
    </>
  )
}
